var _react_refresh_temp_1, _react_refresh_temp_2, _react_refresh_temp_3;
var _react_refresh_temp_4;
_react_refresh_temp_4 = $RefreshSig$();
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useId } from 'react';
import { useParams } from 'react-router-dom';
import { FORBID_SPECIAL_CHARACTERS } from '@lucidlink/sdk';
import { Box, Button, Modal, Trans, translate, Typography, useToastService, } from '@lucidlink/uicore';
import { ModalActions, ModalTitle } from '#components';
import { DEPENDENCY_KEYS, useDependency } from '#context';
const RestrictCharactersContent = ({ closeModal, restrict, titleId, }) => {
    return (_jsxs(_Fragment, { children: [_jsx(ModalTitle, { id: titleId, children: _jsx(Trans, { children: "Would you like to restrict the use of special characters in file and folder names?" }) }), _jsx(Typography, { align: "center", kind: "p", children: _jsx(Trans, { children: "This will block the creation of invalid names on macOS and Linux to ensure compatibility with Windows systems. Existing files and folders will not be affected but may not be usable on Windows unless renamed." }) }), _jsxs(ModalActions, { children: [_jsx(Button, { "data-testid": "cancel-restrict", isFullWidth: true, kind: "secondary", onClick: closeModal, size: "big", children: _jsx(Trans, { children: "Cancel" }) }), _jsx(Button, { "data-testid": "restrict", isFullWidth: true, onClick: restrict, size: "big", children: _jsx(Trans, { children: "Yes, restrict" }) })] })] }));
};
_react_refresh_temp_1 = RestrictCharactersContent;
$RefreshReg$(_react_refresh_temp_1, "RestrictCharactersContent");
const AllowCharactersContent = ({ allow, closeModal, titleId, }) => {
    return (_jsxs(_Fragment, { children: [_jsx(ModalTitle, { id: titleId, children: _jsx(Trans, { children: "Would you like to allow the use of special characters in file and folder names?" }) }), _jsx(Typography, { align: "center", kind: "p", children: _jsx(Trans, { children: "This may lead to the creation of file and folder names that are not compatible with Windows systems." }) }), _jsxs(ModalActions, { children: [_jsx(Button, { "data-testid": "cancel-allow", isFullWidth: true, kind: "secondary", onClick: closeModal, size: "big", children: _jsx(Trans, { children: "Cancel" }) }), _jsx(Button, { "data-testid": "allow", isFullWidth: true, onClick: allow, size: "big", children: _jsx(Trans, { children: "Yes, allow" }) })] })] }));
};
_react_refresh_temp_2 = AllowCharactersContent;
$RefreshReg$(_react_refresh_temp_2, "AllowCharactersContent");
export const SpecialCharacters = ({ closeModal, shouldAllow, }) => {
    _react_refresh_temp_4();
    const { filespaceId = '', workspaceId = '' } = useParams();
    const { addToast } = useToastService();
    const titleId = useId();
    const { mutation: { mutate: setGlobalSettings }, } = useDependency(DEPENDENCY_KEYS.UseSetGlobalSettings)({
        filespaceId,
        workspaceId,
        setting: FORBID_SPECIAL_CHARACTERS,
    }, {
        onSuccess: () => {
            if (shouldAllow) {
                addToast({
                    'data-testid': 'filespace-setting-update-success',
                    hasCloseButton: true,
                    kind: 'positive',
                    content: {
                        message: translate('Special characters have been enabled.'),
                    },
                });
            }
            else {
                addToast({
                    'data-testid': 'filespace-setting-reset-success',
                    hasCloseButton: true,
                    kind: 'positive',
                    content: {
                        message: translate('Special characters have been disabled.'),
                    },
                });
            }
            closeModal();
        },
    });
    return (_jsx(Modal, { "aria-labelledby": titleId, closeModal: closeModal, children: _jsx(Box, { gap: "l", orientation: "vertical", children: shouldAllow ? (_jsx(AllowCharactersContent, { allow: () => setGlobalSettings([
                    {
                        fullName: FORBID_SPECIAL_CHARACTERS,
                        value: '0',
                    },
                ]), closeModal: closeModal, titleId: titleId })) : (_jsx(RestrictCharactersContent, { closeModal: closeModal, restrict: () => setGlobalSettings([
                    {
                        fullName: FORBID_SPECIAL_CHARACTERS,
                        value: '1',
                    },
                ]), titleId: titleId })) }) }));
};
_react_refresh_temp_3 = SpecialCharacters;
$RefreshReg$(_react_refresh_temp_3, "SpecialCharacters");
_react_refresh_temp_4(SpecialCharacters, "vtHZeNLw96etUuaa4DgnWQPQoHA=", false, () => [useParams, useToastService, useDependency]);
